<!-- 
	Registration
	props: N/A
  role: Public
	Called by @/views/Auth to allow public to register for an account
-->

<template>
	<div class="register py-4 text-center">
		<div v-if="error" class="alert -mt-4">
			<Alert>{{ error }}</Alert>
		</div>
		<form autocomplete="on" @submit.prevent="register">
			<div class="form-group">
				<input
					v-model="form.fName"
					type="text"
					placeholder="First Name"
					autocomplete="given-name"
					required
				/>
			</div>
			<div class="form-group">
				<input
					v-model="form.lName"
					type="text"
					placeholder="Last Name"
					autocomplete="family-name"
					required
				/>
			</div>
			<div class="form-group">
				<input
					v-model="form.email"
					type="email"
					placeholder="Email"
					autocomplete="email"
					required
				/>
			</div>
			<div class="form-group">
				<input
					v-model="form.employeeId"
					type="text"
					onkeypress='return event.charCode >= 48 && event.charCode <= 57'
					maxlength="8"
					placeholder="Employee ID"
					autocomplete="off"
					required
				/>
			</div>
			<div class="form-group">
				<input
					v-model="form.passwordInit"
					type="password"
					placeholder="Password"
					autocomplete="new-password"
					required
				/>
			</div>
			<div class="form-group">
				<input
					v-model="form.passwordConfirm"
					type="password"
					placeholder="Confirm Your Password"
					autocomplete="new-password"
					required
				/>
			</div>
			<CustomButton id="cb-gold">Register</CustomButton>
		</form>
	</div>
</template>

<script>
	import firebase from "firebase";

	import CustomButton from "@/components/CustomButton";
	import Alert from "@/components/Alert";

	import { postUserProfile } from "@/utils/api";
	import payrollOptions from "@/assets/payrollOptions.json";

	export default {
		name: "Register",
		components: {
			CustomButton,
			Alert,
		},
		data() {
			return {
				form: {
					fName: "",
					lName: "",
					email: "",
					employeeId: "",
					passwordInit: "",
					passwordConfirm: "",
				},
				companyOptions: payrollOptions,
				error: null,
			};
		},
		methods: {
			register() {
				if (this.form.employeeId.length != 8) {
					this.error = "Employee ID must be 8-digit long";
				}
				else{

				if (this.form.passwordInit === this.form.passwordConfirm) {
					// if passwords are same continue
					const ref = firebase
						.firestore()
						.collection("users")
						.doc(this.form.employeeId);

					ref.get().then((doc) => {
						if (doc.exists) {
							// if employee id entered is already in use trigger error and fail
							this.error = "This Employee ID is already in use";
							return;
						} else {
							// if employee id has not been used then continue to create user
							firebase
								.auth()
								.createUserWithEmailAndPassword(
									this.form.email,
									this.form.passwordConfirm
								)
								.then((data) => {
									data.user
										.updateProfile({
											displayName: this.form.email,
										})
										.then(() => {
											const db = firebase.firestore();

											const employeeID = this.form.employeeId;

											const userData = {
												firstName: this.form.fName,
												lastName: this.form.lName,
												email: this.form.email,
												employeeId: this.form.employeeId,
												createdAt: new Date(),
												isStrideAdmin: false,
											};

											const authData = {
												authId: data.user.uid,
												emailAddress: this.form.email,
											};

											db.collection("users")
												.doc(employeeID)
												.set(userData)
												.then(() => {
													firebase.auth().currentUser.sendEmailVerification();

													const res = postUserProfile(authData);

													firebase
														.auth()
														.signOut()
														.then(() => {
															this.$store.dispatch("fetchUser", null);

															this.$store.dispatch(
																// throw modal telling user to verify their email
																"setError",
																"<div class='leading-8'><div class='text-2xl'>Your Account has been created.</div><div>Please check your inbox for a confirmation email.</div><div>Click the link in the email to confirm your email address.</div><div class='text-sm'>Don't see the email? Check your junk mail.</div></div>"
															);

															this.register = false;
															this.$store.commit("formLogin", this.register);

															this.$router.replace({
																name: "Auth",
															});
														});
												})
												.catch((err) => {
													console.log(err);
												});
										});
								})
								.catch((err) => {
									this.error = err.message;
								});
						}
					});
				} else {
					// throw alert
					this.error = "Passwords do not match";
				}
			}
			},
		},
	};
</script>

<style scoped>
	.form-group {
		margin: 12.5px 0;
	}

	form .form-group input {
		border-bottom: 1px solid #ffffff;
		width: 270px;
		padding: 1px 3px 5px;
		background-color: transparent;
		color: #ffffff;
	}

	form .form-group select {
		border: 0.5px solid gray;
		width: 270px;
		padding: 1px 5px;
	}
</style>
